import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import Header from "./sections/header";
import HeroSection from "./sections/hero";
import FeaturesList from "./sections/features";
import Download from "./sections/download";
import Footer from "./sections/footer";

import './scss/style.scss';

    let url = window.location;

    let metaIOS = document.createElement('meta');
    let metaAndroid = document.createElement('meta');
    metaIOS.setAttribute("property", 'al:ios:url');
    metaAndroid.setAttribute("property", 'al:android:url');
    const params = url.pathname.split('/');
    const checkParamsArray = params.splice(1, params.length);
    if ((checkParamsArray[0] === 'articles' || checkParamsArray[0] === 'events') && metaIOS) {
      metaIOS.setAttribute("content", `applinks://comsoftconstructspringbme://${checkParamsArray.join('/')}`);
      metaAndroid.setAttribute("content", `applinks://comsoftconstructspringbme://${checkParamsArray.join('/')}`);
    } else {
      metaIOS.setAttribute("content", `applinks://comsoftconstructspringbme://`);
      metaAndroid.setAttribute("content", `applinks://comsoftconstructspringbme://`);
    }
    document.getElementsByTagName('head')[0].prepend(metaIOS);
    document.getElementsByTagName('head')[0].prepend(metaAndroid);
    console.log(metaIOS);
    console.log(metaAndroid);


ReactDOM.render(
  <React.StrictMode>
      <Header />
      <HeroSection />
      <div className="content-section">
          <FeaturesList />
          <Download />
      </div>
      <Footer />
  </React.StrictMode>,
  document.getElementById('root')
);
